module.exports = __webpack_public_path__ + "img/ydsj.6c532cf9.svg";